module.exports = __webpack_public_path__ + "img/5.2a5ee493.jpg";